import React from 'react';
import Items, { defaultConfigComponent as ItemsConfig } from '../Items/Items';
import { IConfigComponent, TFlavor } from '@ts/ui-models';
import { CDevice } from '@ts/ui-models';
import { IWrapperDataGridProps } from '@modules/dataGrid/WrapperDataGrid';
import { TTextType } from '@ts/storybook';

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...ItemsConfig,
    componentId: 'devices',
    entity: 'device',
    fetchURL: '/api/v2/items',
    filtersFetchData: { device: { isAlive: true } },
    mainClass: CDevice,
  };
};

interface IDevicesProps {
  title?: TTextType;
  fetchURL?: string;
  configComponent?: IConfigComponent;
}

const Devices = ({ title, configComponent, ...restProps }: IDevicesProps) => {
  const defaultProps = {
    flavorId: 'device' as TFlavor,
    title: title || 'Devices',
    nameColumns: ['defaultLocation', 'currentLocation', 'lastPosition', 'attachedTo'],
  };

  return (
    <Items
      configComponent={{
        ...defaultConfigComponent(),
        ...configComponent,
      }}
      {...defaultProps}
      {...restProps}
    />
  );
};

export default Devices;
